const init = (env) => {
  const environment = process.env.REACT_APP_ENV ? process.env.REACT_APP_ENV : "dev";
  console.log("INIT : "+ environment)
  try {
    setConfig(require("./" + environment + ".json"));
  } catch (e) {
    console.error(`Impossibile caricare la configurazione per: ${environment}`, e);
    setConfig(require("./dev.json"));
  }
};

const setConfig = (config) => {
  window.config = config;
};

const getConfig = () => {
  return window.config;
};

export default {
  init: init,
  getConfig: getConfig,
};
